import(/* webpackMode: "eager", webpackExports: ["BlogOverview"] */ "/tmp/8de795977415867/app/[locale]/blog/BlogOverview.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/app/[locale]/blog/page.module.css");
